(() => {
  let inFlight = false;       // prevent double-runs
  let redirected = false;     // ensure single redirect

  
async function runCartAdjustments() {
  console.log('running cart adjustments');

  const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
  const data = await res.json();

  const cartItems = data.items || [];
  const productsToUpdate = [];
  const productsToAdd = [];

  if (cartItems.length === 0) {
    return { added: false, updated: false, skipped: true };
  }

  cartItems.forEach((i) => {
    if (typeof i.properties['_options_addon_products'] !== 'undefined') {

      const optionsGuid = i.properties['_options_group_id'];
      const optionsQty  = i.quantity;
      const addOns      = JSON.parse(i.properties['_options_addon_products']);

      addOns.forEach((a) => {
        const ext = cartItems.filter(x =>
          x.variant_id == a.variantId &&
          x.properties['_options_action'] == a.actionID &&
          x.properties['_options_group_id'] == optionsGuid
        );

        if (ext.length === 1) {
          if (ext[0].quantity != optionsQty) {
            productsToUpdate.push({
              key: ext[0].key,
              quantity: optionsQty
            });
          }
        }

        if (ext.length === 0) {
          productsToAdd.push({
            quantity: optionsQty,
            id: a.variantId,
            properties: {
              "_options_group_id": optionsGuid,
              "_options_hidden": 'true',
              "_options_action": a.actionID
            }
          });
        }
      });

    } else if (typeof i.properties['_options_hidden'] !== 'undefined') {
      console.log('checking for missing parents');
      const optionsGuid = i.properties['_options_group_id'];
      const parent = cartItems.filter(x =>
        x.properties['_options_group_id'] == optionsGuid &&
        x.properties['_options_addon_products']
      );

      console.log(parent);

      if (parent.length <= 0) {
        console.log('removing:');
        productsToUpdate.push({
          key: i.key,
          quantity: 0
        });
      }
    }
  });

  return updateCart(productsToUpdate, productsToAdd);
}

async function updateCart(productsToUpdate, productsToAdd) {
  console.log('updating cart...');

  const addP = addProducts(productsToAdd);
  const updP = updateProducts(productsToUpdate);

  const results = await Promise.allSettled([addP, updP]);

  const summary = {
    added: (productsToAdd?.length || 0) > 0,
    updated: (productsToUpdate?.length || 0) > 0,
    results
  };

  console.log('updating cart finished...', summary);
  return summary;
}

function addProducts(productList){
    console.log('adding products...');
    if (!productList || productList.length === 0) {
      return Promise.resolve({ skipped: true, op: 'add' });
    }

    let formData = {
        'items': productList
    };

    return fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
    }).then(r => {
      if (!r.ok) throw new Error('Add products failed: ' + r.status);
      return r.json();
    });
}

function updateProducts(updateList){
     console.log('updating products...');
  if (!updateList || updateList.length === 0) {
    return Promise.resolve({ skipped: true, op: 'update' });
  }

  const formData = new FormData();
  updateList.forEach(u => {
    formData.append(`updates[${u.key}]`, String(u.quantity));
  });

  return fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
    method: 'POST',
    body: formData
  }).then(r => {
    if (!r.ok) throw new Error('Update products failed: ' + r.status);
    return r.json();
  });
}



  function proceedToCheckout(e) {
    console.log('redirect to checkout...');
    if (redirected) return;
    redirected = true;

    window.location.assign('/checkout');

    // OR find element and initiate the click event
    //     const el = document.querySelector(checkoutClickSelector);
    //     if (el) {
    //       console.log('[Checkout Interceptor] Clicking detected checkout element:', el);
    //       el.click();
    //       return;
    //     }

  }

  async function handleBeginCheckout(e) {
    console.log('begin checkout');
    // Stop everything else from acting on this event
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    if (inFlight) return; // already handling this click/submit
    inFlight = true;

    try {
      await runCartAdjustments();
    } catch (err) {
      console.warn('Cart adjustment failed; continuing to checkout anyway.', err);
      
    } finally {
      proceedToCheckout(e);
      inFlight = false;
    }
  }

  // Intercept submit on the cart form (covers Enter key and most buttons)

  const w3checkoutbtn = document.querySelector(".w3-checkout");
    if (w3checkoutbtn) {
        w3checkoutbtn.addEventListener('click', (e) => {
             handleBeginCheckout(e);
        })
      
    }
//   document.addEventListener('submit', (e) => {
//     const form = e.target;
//     if (form && form.matches('form[action="/cart"]')) {
//       handleBeginCheckout(e);
//     }
//   }, { capture: true });

//   // Intercept click on common checkout triggers
//   const extraSelectors = Array.isArray(window.additionalCheckoutSelectors)
//   ? window.additionalCheckoutSelectors
//   : [];

//   // Combine base and extras
//   const checkoutClickSelector = [...baseCheckoutSelectors, ...extraSelectors].join(',');

//   document.addEventListener('click', (e) => {
//     const el = e.target.closest(checkoutClickSelector);
//     if (el) {
//       handleBeginCheckout(e);
//     }
//   }, { capture: true });



// Optional: MutationObserver to “neutralize” rogue inline onclick handlers
//--------------------------------------------------------------------------
//   const mo = new MutationObserver((muts) => {
//     muts.forEach(m => {
//       m.addedNodes && m.addedNodes.forEach(n => {
//         if (!(n instanceof Element)) return;
//         n.querySelectorAll?.(checkoutClickSelector).forEach(btn => {
//           // Remove inline onclick to force our handler path
//           if (btn.hasAttribute('onclick')) btn.removeAttribute('onclick');
//         });
//       });
//     });
//   });
//   mo.observe(document.documentElement, { childList: true, subtree: true });


  // Optional: Global guard—if another script tries to redirect after you,
  //--------------------------------------------------------------------------
//   const originalAssign = window.location.assign.bind(window.location);
//   window.location.assign = function(url) {
//     if (redirected) return; // block additional redirects after ours
//     return originalAssign(url);
//   };
})();